import { Database, ref, set } from 'firebase/database';

export const enrollmentAvailableUpdate = async (
  database: Database,
  enrollmentAvailable: boolean,
): Promise<void> => {
  return set(ref(database, 'settings/enrollmentAvailable'), Boolean(enrollmentAvailable));
};
